import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoGridMixin from './KendoGridMixin'

export default {
    name: 'kendo-grid',
    mixins: [ KendoGridMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
        return h('div', [
            this.$slots['kendo-datasource'],
            defaultSlot
        ])
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGrid/index.js